import { cn } from "@/utils/cn";
import { memo } from "react";

interface ThumbsDownIconProps {
  className?: string;
}

/**
 * Thumbs Down Icon component
 * Used for dislike/disapprove actions
 */
export const ThumbsDownIcon = memo(function ThumbsDownIcon({ className }: ThumbsDownIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M22.9133 14.9688L21.7883 5.96875C21.7198 5.42489 21.4551 4.92475 21.0439 4.56224C20.6327 4.19974 20.1033 3.99981 19.5552 4H3.43018C3.03235 4 2.65082 4.15804 2.36952 4.43934C2.08821 4.72064 1.93018 5.10218 1.93018 5.5V13.75C1.93018 14.1478 2.08821 14.5294 2.36952 14.8107C2.65082 15.092 3.03235 15.25 3.43018 15.25H7.46705L11.0089 22.3356C11.0713 22.4602 11.1671 22.565 11.2857 22.6382C11.4042 22.7114 11.5408 22.7501 11.6802 22.75C12.6747 22.75 13.6286 22.3549 14.3318 21.6516C15.0351 20.9484 15.4302 19.9946 15.4302 19V17.5H20.6802C20.9995 17.5001 21.3151 17.4323 21.6062 17.301C21.8972 17.1697 22.157 16.978 22.3682 16.7385C22.5794 16.4991 22.7373 16.2175 22.8313 15.9123C22.9252 15.6072 22.9532 15.2855 22.9133 14.9688ZM7.18018 13.75H3.43018V5.5H7.18018V13.75ZM21.2427 15.7459C21.1728 15.8263 21.0863 15.8907 20.9892 15.9345C20.8921 15.9784 20.7867 16.0007 20.6802 16H14.6802C14.4813 16 14.2905 16.079 14.1498 16.2197C14.0092 16.3603 13.9302 16.5511 13.9302 16.75V19C13.9303 19.5202 13.7502 20.0244 13.4205 20.4267C13.0908 20.8291 12.6318 21.1048 12.1217 21.2069L8.68018 14.3228V5.5H19.5552C19.7379 5.49994 19.9144 5.56658 20.0514 5.68742C20.1885 5.80825 20.2767 5.97496 20.2996 6.15625L21.4246 15.1562C21.4386 15.2618 21.4296 15.3692 21.3982 15.471C21.3668 15.5728 21.3138 15.6666 21.2427 15.7459Z"
        fill="currentColor"
      />
    </svg>
  );
});
